module.exports = __webpack_public_path__ + "static/media/icon_youtube.947a3c56.svg";